import { ActionContext, ActionTree } from 'vuex';
import { RootState, SharingState } from '@/store/types';
import UserService from '@/services/user.service';
import { InviteToAccept } from '@/models/inviteToAccept';
import { Invitation } from '@/models/invitation';

const actions: ActionTree<SharingState, RootState> = {
  async download(store: ActionContext<SharingState, RootState>): Promise<void> {
    store.commit('clearErrors');
    return UserService.getInvitations()
      .then(invitations => {
        store.commit('setInvitations', invitations);
      })
      .catch(error => {
        store.commit('setGetError', error);
      });
  },

  async send(store: ActionContext<SharingState, RootState>): Promise<void> {
    store.commit('clearErrors');
    return UserService.postInvitation()
      .then(invitation => {
        store.commit('add', invitation);
        store.commit('clearInvite');
      })
      .catch(error => {
        store.commit('setPostError', error);
      });
  },

  async remove(store: ActionContext<SharingState, RootState>): Promise<void> {
    store.commit('clearErrors');
    return UserService.deleteInvitation()
      .then(() => {
        store.commit('remove');
      })
      .catch(error => {
        store.commit('setDeleteError', error);
      });
  },

  async accept(
    store: ActionContext<SharingState, RootState>,
    invite: InviteToAccept
  ): Promise<void> {
    store.commit('clearErrors');
    return UserService.acceptInvitation(invite).catch(error => {
      store.commit('setPostError', error);
    });
  },

  async get(
    store: ActionContext<SharingState, RootState>,
    invite: InviteToAccept
  ): Promise<Invitation> {
    return UserService.getInvitation(invite)
      .then((invitation: Invitation) => {
        return Promise.resolve(invitation);
      })
      .catch(error => {
        return Promise.reject(error.message);
      });
  },
};

export default actions;
